import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "src/app/base/services/base.service";
import { ObrasAdminGeral } from "../models/obras-admin-geral.model";

@Injectable()
export class ObrasAdminGeralService extends BaseService<ObrasAdminGeral> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public updateGeral(obj: ObrasAdminGeral): Observable<ObrasAdminGeral> {
    return this.http.put<ObrasAdminGeral>(this.baseUrl, obj, { headers: this.headers });
  }

  public getPathModule(): string {
    return '/qrobras/admin-geral';
  }
}